import React, { useEffect } from "react";
import NavbarNews from "../../Components/NewsNew/NavbarNews";
import HeroNews from "../../Components/NewsNew/HeroNews";
import NewsGridNews from "../../Components/NewsNew/NewsGridNews";
import NewsletterNews from "../../Components/NewsNew/NewsletterNews";
import FeaturedNewsNews from "../../Components/NewsNew/FeaturedNewsNews";
import MoreFromUsNews from "../../Components/NewsNew/MoreFromUsNews";
import WatchNowNews from "../../Components/NewsNew/WatchNowNews";
import BlueBannerNews from "../../Components/NewsNew/BlueBannerNews";
import { scrollToTop } from "../../helper/helper";
import FooterNew from "../../Components/LandingNew/FooterNew";

export default function NewsNew() {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div
      className="min-h-screen bg-black text-white flex flex-col justify-between overflow-x-hidden bg-cover bg-center bg-no-repeat bg-fixed relative"
    // style={{ backgroundImage: `url(${newsBg})` }}
    >
      {/* Overlay to dim the background for text readability */}
      <div className="absolute inset-0 bg-black/75 pointer-events-none"></div>

      <div className="relative z-10 flex flex-col">
        {/* Navbar */}
        <NavbarNews />

        {/* Hero Section */}
        <HeroNews />

        {/* News Grid (3 Columns) */}
        <NewsGridNews />

        {/* Newsletter Section */}
        <NewsletterNews />

        {/* Featured / Large News list */}
        <FeaturedNewsNews />

        {/* More From Us Section */}
        <MoreFromUsNews />

        {/* Watch Now Section */}
        <WatchNowNews />
      </div>

      {/* Footer & Notification Banner */}
      <div className="relative z-10">
        <BlueBannerNews />
        <FooterNew
          fbLink={"https://www.facebook.com/bab.media.2024/"}
          instaLink={"https://www.instagram.com/bab_media_/"}
        />

      </div>
    </div>
  );
}
